import React from "react";
import { Column } from "@/components/Datatable/types";
import { Badge } from "@/components/Badge/Badge";
import StageActionMenu from "../StageActionMenu/StageActionMenu";
import { Stage } from "../../api/getStages/types";

interface CreateStageColumnsProps {
  onView: (stage: Stage) => void;
  onEdit: (stage: Stage) => void;
  onDelete: (stage: Stage) => void;
}

export function createStageColumns({
  onView,
  onEdit,
  onDelete,
}: CreateStageColumnsProps): Column<Stage>[] {
  return [
    {
      header: "Name",
      accessorKey: "name",
      enableSorting: true,
      cell: ({ row }) => row.original.name || "—",
    },
    {
      header: "Position",
      accessorKey: "position",
      enableSorting: false,
      cell: ({ row }) => row.original.position ?? "—",
    },
    {
      header: "Description",
      accessorKey: "description",
      enableSorting: true,
      cell: ({ row }) => row.original.description || "—",
    },
    {
      header: "Status",
      accessorKey: "isDeleted",
      cell: ({ row }) =>
        row.original.isDeleted ? (
          <Badge variant="grey">Inactive</Badge>
        ) : (
          <Badge variant="success">Active</Badge>
        ),
    },
    {
      id: "actions",
      header: "Actions",
      cell: ({ row }) => (
        <StageActionMenu
          onDelete={onDelete}
          onEdit={onEdit}
          onView={onView}
          stage={row.original}
        />
      ),
    },
  ];
}
